import {EContentType} from 'src/constants';

import {
  BUTTON_NAME_MAX_LENGTH,
  ETemplateButtonOtpType,
} from '../MessageMatchers/WhatsAppForm/definitions';
import {EMessageMatcherButtonTypes} from '../MessageMatchers/definitions';
import {EMenuButtonAction} from './Item/types';
import {ECommonMenuType} from './Layout/constants';
import {EFlowStatus, EFlowStepType, EUIActionType, EUIConditionType} from './types';

export default {
  createTrigger: 'сценарий',
  toList: 'К списку',
  empty: {
    title: 'Здесь пока пусто',
  },
  status: {
    [EFlowStatus.DRAFT]: 'Черновик',
    [EFlowStatus.ACTIVE]: 'Активен',
    [EFlowStatus.INACTIVE]: 'Остановлен',
    [EFlowStatus.SCHEDULED]: 'Запланирован',
    [EFlowStatus.FINISHED]: 'Завершен',
  },
  type: {
    [EFlowStepType.TRIGGER]: 'Стартовый блок',
    [EFlowStepType.CONDITION]: 'Условие',
    [EFlowStepType.ACTION]: 'Действие',
  },
  changeCondition: 'Изменить условие',
  blockSettings: 'Настройки блока',
  transitions: 'Переходов: {{count}}',
  description: {
    [EFlowStepType.TRIGGER]: 'Условие, с которого начнется ваш сценарий',
    [EFlowStepType.CONDITION]: 'Выберите условие',
    [EFlowStepType.ACTION]: 'Выберите действие',
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]: 'Диалог с получателем переводится в edna Chat Center',
    [EUIActionType.PAUSE_ACTION]: 'Во время паузы абонент не получает сообщений от сценария',
    [EUIActionType.ADD_SUBSCRIBER_TAG_ACTION]: 'Всем получателям будут присвоены указанные теги',
    [EUIActionType.DELETE_SUBSCRIBER_TAG_ACTION]: 'Всем получателям будут удалены указанные теги',
    [EUIConditionType.TAG_PRESENCE_CONDITION]: 'Выбрать абонентов на основе тегов',
    [EUIConditionType.BUTTON_PRESSED]: 'Выбрать абонентов, которые нажали кнопки в сообщении',
    [EUIConditionType.MESSAGE_RECEIVED]: 'Выбрать абонентов, которые направили входящее сообщение',
    [EUIConditionType.EXTERNAL_TRIGGER]: 'Получатели, для которых будет запущен внешний триггер',
  },
  title: {
    [EUIActionType.PAUSE_ACTION]: 'Сценарий ожидает ответ клиента в течение',
  },
  trigger: {
    [EUIConditionType.MESSAGE_RECEIVED]: {
      title: 'Получено входящее сообщение',
      subtitle: 'Пользователь ответил на сообщение',
    },
    [EUIConditionType.EXTERNAL_TRIGGER]: {
      title: 'Внешний триггер',
      subtitle: 'Получатели, для которых будет запущен внешний триггер',
    },
    [EUIConditionType.ANSWER_TIMEOUT_CONDITION]: {
      title: 'на выполнение любого из этих условий',
    },
    [EUIConditionType.BUTTON_PRESSED]: {
      title: 'Нажатие кнопки в сообщении',
      buttonLabel: 'Название кнопки',
      buttonId: 'Код кнопки',
      emptySubtitle: 'Значения кнопок не настроены',
    },
    [EUIConditionType.TAG_ASSIGN_TIMEOUT_CONDITION]: {
      title: 'Время присвоения тега',
      delay: 'С момента присвоения тега прошло',
      tags: 'Присвоенный тег',
    },
    [EUIConditionType.TAG_PRESENCE_CONDITION]: {
      title: 'Наличие тегов',
      include: 'Включить',
      exclude: 'Исключить',
    },
    [EUIActionType.ADD_SUBSCRIBER_TAG_ACTION]: 'Присвоить теги',
    [EUIActionType.DELETE_SUBSCRIBER_TAG_ACTION]: 'Удалить теги',
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]: 'Перевести на оператора',
    [EUIActionType.SEND_MESSAGE_ACTION]: 'Отправить шаблонное сообщение WhatsApp',
    [EUIActionType.CREATE_MESSAGE_ACTION]: 'Отправить сообщение WhatsApp',
    [EUIActionType.PAUSE_ACTION]: 'Ожидание ответа',
  },
  triggerDescription: {
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]: 'Перевод диалога в edna Chat Center',
  },
  createMessageAction: {
    messageText: 'Текст сообщения',
    addButtons: 'Добавить кнопки',
    addButton: 'Добавить кнопку',
    buttonsLimit: 'До трех кнопок чата',
    buttonTitle: 'Кнопка чата',
    buttonText: `Текст кнопки (до ${BUTTON_NAME_MAX_LENGTH} символов)`,
    buttonCode: `Код кнопки, payload (до 256 символов)`,
    viewMessage: 'Просмотреть сообщение',
  },
  pauseAction: {
    createMessageHint:
      'Если следующим блоком будет действие «Отправить сообщение WhatsApp», помните, что ожидание не может быть более 23 часов 59 минут, так как нешаблонное сообщение можно отправить только в течение суток после последнего ответа пользователя',
  },
  sendMessageAction: {
    template: 'Шаблон',
    ignoreSchedule: 'Игнорировать расписание сценария',
    messageMatcherId: 'Выберите шаблон сообщения, доступный для этого канала',
    hasAttachment: {
      [EContentType.IMAGE]:
        'В этом шаблоне есть заголовок-картинка. Загрузите файл с изображением или введите ссылку на него.',
      [EContentType.VIDEO]:
        'В этом шаблоне есть заголовок-видео. Загрузите файл с видео или введите ссылку на него.',
      [EContentType.DOCUMENT]:
        'В этом шаблоне есть заголовок-документ. Загрузите файл документа или введите ссылку на него.',
    },
    upload: 'Загрузить с компьютера',
    addLink: 'Вставить ссылку на файл',
    imageHint: 'Картинка (PNG или JPG до 5 МБ)',
    viewTemplate: 'Посмотреть шаблон',
    linkHint: {
      [EContentType.IMAGE]: 'Ссылка на картинку (до 200 символов)',
      [EContentType.VIDEO]: 'Ссылка на видео (до 200 символов)',
      [EContentType.DOCUMENT]: 'Ссылка на документ (до 200 символов)',
    },
    button: 'Кнопка',
    buttonName: 'Название',
    attachFile: 'Загрузить файл',
    buttonText: 'Текст кнопки',
    buttonCode: 'Код кнопки',
    buttonType: 'Тип кнопки',
    buttonTypeLabel: {
      [EMessageMatcherButtonTypes.PHONE]: 'Кнопка-звонок',
      [EMessageMatcherButtonTypes.URL]: 'Кнопка-ссылка',
      [EMessageMatcherButtonTypes.CHAT]: 'Кнопка чата',
      [ETemplateButtonOtpType.COPY]: 'Копировать код',
      [ETemplateButtonOtpType.AUTO]: 'Автоматическое заполнение',
    },
    staticUrl: 'Статическая часть ссылки',
    dynamicUrl: 'Динамическая часть ссылки',
    phoneNumber: 'Номер телефона',
    viewMessage: 'Просмотр сообщения',
    back: 'Назад',
    done: 'Готово',
    dynamicUrlRequired: 'Динамическая часть ссылки должна быть заполнена',
  },
  forms: {
    [EUIConditionType.BUTTON_PRESSED]: {
      button: 'Кнопка',
      buttonLabel: 'Название кнопки (должно совпадать с шаблоном)',
      buttonId: 'Код кнопки, payload (должен совпадать с шаблоном)',
      addButton: 'Добавить кнопку',
    },
    [EUIConditionType.TAG_ASSIGN_TIMEOUT_CONDITION]: {
      delay: 'С момента присвоения тега получателю прошло',
      tags: 'Тег, присвоенный получателю',
    },
    [EUIConditionType.TAG_PRESENCE_CONDITION]: {
      tagsTree: 'Дерево тегов',
    },
    [EUIConditionType.ANSWER_TIMEOUT_CONDITION]: {
      title: 'Настроить блок условий',
      hint_1: [
        'Вместе с условием Нажатие кнопки в сообщении одновременно подключится условие Получено входящее сообщение.',
        'Так вы не потеряете пользователей, которые в ответ на сообщение не нажмут на кнопку, но сами напишут вам.',
      ].join('<br/>'),
      hint_2:
        'Для тех, кто напишет входящее сообщение, из этого блока можно построить отдельную ветку сценария. ',
      hint_3: 'На выполнение любого из этих условий будет действовать одно время ожидания ответа.',
      answerTimeout: 'Время ожидания ответа:',
      save: 'Сохранить настройку',
    },
  },
  tag: 'Тег',
  systemWaiting: 'Ожидание в течение',
  condition: {
    yes: 'Да',
    no: 'Нет',
    notCompleted: 'Не выполнено',
  },
  contextMenu: {
    add: 'Добавить',
    deleteEdge: 'Удалить',
    deleteBlock: 'Удалить блок?',
    duplicateBlock: 'Дублировать блок',
    deleteTrigger: 'Удалить триггер?',
    duplicateTrigger: 'Дублировать триггер',
  },
  addButton: {
    [EFlowStepType.TRIGGER]: 'Выбрать условие',
    [EFlowStepType.CONDITION]: 'Выбрать условие',
    [EFlowStepType.ACTION]: 'Выбрать действие',
  },
  menu: {
    [EFlowStepType.ACTION]: 'Действие',
    [EFlowStepType.CONDITION]: 'Условие',
    [ECommonMenuType.SETTINGS]: 'Настройки',
    [ECommonMenuType.HELP]: 'Помощь',
    [ECommonMenuType.NOTIFICATIONS]: 'Журнал событий',
    [ECommonMenuType.SIGN_OUT]: 'Выход',
  },
  actionButton: {
    [EMenuButtonAction.START]: 'Запустить сценарий',
    [EMenuButtonAction.STOP]: 'Остановить сценарий',
    [EMenuButtonAction.SETTINGS]: 'Посмотреть настройки',
    [EMenuButtonAction.VIEW]: 'Посмотреть сценарий',
    [EMenuButtonAction.EDIT]: 'Редактировать сценарий',
    [EMenuButtonAction.COPY]: 'Копировать сценарий',
    [EMenuButtonAction.CANCEL]: 'Отменить запуск',
    [EMenuButtonAction.DELETE]: 'Удалить сценарий',
  },
  filters: {
    searchPlaceholder: 'Быстрый поиск по названию',
    flows: 'Сценариев',
  },
  th: {
    activatedAt: 'Дата запуска',
    name: 'Название сценария',
    status: 'Статус',
    started: 'Запущено',
    startedHint: 'Количество абонентов, для которых сработал стартовый блок сценария',
    inProgress: 'Выполняется',
    inProgressHint: 'Количество абонентов, которые проходят сценарий',
    finished: 'Завершено',
    finishedHint: 'Количество абонентов, для которых сценарий завершился успешно',
  },
  successModal: {
    [EMenuButtonAction.START]: {
      title: 'Сценарий успешно запущен!',
      message: 'Статистика переходов по шагам сценария будет отображаться в списке сценариев',
      confirmButton: 'Ок',
    },
  },
  modal: {
    [EMenuButtonAction.STOP]: {
      title: 'Остановить сценарий?',
      message: 'Сейчас в этом сценарии нет активных участников.',
      titleActive: 'Остановить сценарий с участниками?',
      messageActive:
        'В сценарий вовлечены <0>{{count}} участников.</0> Если вы остановите сейчас, участники не смогут его завершить.',
      confirmButton: 'Остановить',
    },
    [EMenuButtonAction.START]: {
      title: 'Запустить сценарий?',
      message: 'После запуска сценария вы не сможете его больше редактировать',
      confirmButton: 'Запустить',
    },
    [EMenuButtonAction.CANCEL]: {
      title: 'Отменить запуск сценария?',
      message:
        'После отмены запустить сценарий снова невозможно. Чтобы использовать этот сценарий повторно, его необходимо скопировать и сохранить с новым названием и расписанием.',
      confirmButton: 'Отменить запуск',
    },
    [EMenuButtonAction.DELETE]: {
      title: 'Удалить сценарий?',
      message:
        'Если вы удалите сценарий, все настройки, которые в нем содержатся, также будут удалены. Вы уверены?',
      confirmButton: 'Удалить',
    },
    [EMenuButtonAction.COPY]: {
      title: 'Копировать сценарий?',
      message:
        'Все блоки и связи этого сценария продублируются, но вам потребуется задать другое имя сценария и заново выставить расписание.',
      confirmButton: 'Копировать',
    },
    [EFlowStepType.TRIGGER]: {
      title: 'Выберите триггер, который запустит ваш сценарий',
    },
    [EFlowStepType.CONDITION]: {
      title: 'Выберите условие',
    },
    [EFlowStepType.ACTION]: {
      title: 'Выберите действие',
    },
    saveError: {
      title: 'Сохранение невозможно, в нем есть ошибки',
      message:
        'Мы не можем сохранить сценарий с ошибками внутри. Исправьте ошибки в блоках, подсвеченных красным, и сохраните сценарий еще раз',
      confirmButton: 'Исправить ошибки',
      cancelButton: 'Не сохранять',
    },
    saveCyclesError: {
      title: 'Внутри сценария есть замкнутый цикл',
      message:
        'В сценарии есть место, где блоки зациклены между собой. Это может привести к тому, что клиенты будут повторно проходить одни и те же этапы.',
      confirmButton: 'Сохранить как есть',
      checkButton: 'Вернуться и проверить',
    },
    activateCyclesError: {
      title: 'Запустить с циклом внутри?',
      message:
        'В сценарии есть место, где блоки зациклены между собой. Это может привести к тому, что клиенты будут повторно проходить одни и те же этапы.',
      confirmButton: 'Запустить как есть',
      checkButton: 'Вернуться и проверить',
    },
    confirmLeave: {
      title: 'Сохранить сценарий?',
      message:
        'Если выйти из сценария, не сохранив его, все ваши данные сотрутся и нужно будет все создавать заново',
      confirmButton: 'Выйти',
    },
  },
  notification: {
    activateSuccess: 'Сценарий успешно запущен',
    deactivateSuccess: 'Сценарий остановлен',
    saveSuccess: 'Сценарий успешно сохранен',
    saveError: 'Сценарий не сохранится, возникла неизвестная ошибка',
  },
  errors: {
    tagsRequired: 'Необходимо выбрать хотя бы один тег',
    missingData: 'Не введены настройки блока. Сценарий не может быть запущен',
    missingTriggerData: 'Необходимо настроить условие в стартовом блоке',
    notLastFlowStep: 'Условие не может быть последним блоком цепочки',
    messageTimeoutTooLong:
      'Действие невозможно: отправить нешаблонное сообщение можно только в течение 24ч с момента ответа пользователя. Измените действие или время ожидания в предыдущем блоке',
    emptyButtonCondition: 'Выберите значения кнопок',
  },
};
